import {
  computeOfferReviewBanner,
  computeOfferReviewStatusPill,
  type ClientOfferReviewBannerModelLabels,
} from '../../client-offer-review';

interface BuildReviewBannerParams {
  bannerState: 'sent' | 'expired' | 'accepted' | 'rejected';
  isPreview: boolean;
  accCount: number;
  accValue: number;
  labels: ClientOfferReviewBannerModelLabels;
}

export function buildReviewBanner({
  bannerState,
  isPreview,
  accCount,
  accValue,
  labels,
}: BuildReviewBannerParams) {
  const flags = {
    isAccepted: bannerState === 'accepted',
    isRejected: bannerState === 'rejected',
    isExpired: bannerState === 'expired',
  };
  return {
    banner: computeOfferReviewBanner({ ...flags, isPreview, accCount, accValue, labels }),
    statusPill: computeOfferReviewStatusPill({ ...flags, labels }),
  };
}
